export const setTitleByChannelName = channelName => {
  switch(channelName) {
    case 'all': {
      return 'All Channels'
    }
    case 'apple': {
      return 'Apple Business Chat'
    }
    case 'rbm': {
      return 'Google RBM'
    }
    
    case 'messenger':
    case 'facebook': {
      return 'Facebook'
    }

    case 'rocketchat': {
      return 'RocketChat'
    }

    case 'liveperson': {
      return 'LivePerson'
    }

    case 'khoros': {
      return 'Khoros'
    }

    case 'mavenir': {
      return 'Mavenir'
    }

    case 'telegram': {
      return 'Telegram'
    }

    case 'twilio': {
      return 'Twilio'
    }

    case 'twitter': {
      return 'Twitter'
    }

    case 'slack': {
      return 'Slack'
    }

    case 'messagemedia': {
      return 'MessageMedia'
    }

    case 'viber': {
      return 'Viber'
    }

    case 'sparkcentral': {
      return 'Sparkcentral'
    }

    case 'wit': {
      return 'Wit'
    }
    
    case 'front': {
      return 'Front'
    }

    case 'rest': {
      return 'Rest'
    }

    case 'kik': {
      return 'Kik'
    }

    case 'socket_sdk': {
      return 'SDK'
    }

    case 'socket': {
      return 'Web & Socket API'
    }

    case 'socketsdk': {
      return 'Socket SDK'
    }

    case 'alexa': {
      return 'Alexa'
    }

    case 'whatsapptest':
    case 'whatsapp': {
      return 'WhatsApp'
    }

    default: {
      return channelName
    }
  }
}

export const getFilterTitles = filter => {
  switch(filter){
    case 'all': return 'All Messages'
    case 'assignee': return 'Assigned to me'
    case 'archived': return 'Archived'
    case 'inboxes': return 'Inboxes'
    case 'deleted': return 'Deleted'
    default: return 'Unknown Filter'
  }
}